/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  publisheruser: {
    '& .editbutton': {
      display: 'flex',
      gap: pxToEm(8),
      height: '24px',
      alignItems: 'center',
      background: '#E8EBF7',
      padding: pxToEm(8),
      borderRadius: pxToEm(8),
      fontSize: pxToEm(12)
    },
    '& .explainer': {
      '& ul': {
        paddingLeft: pxToEm(20),
        marginBottom: pxToEm(20),
        '& li': {
          fontSize: pxToEm(14),
          marginBottom: pxToEm(10)
        }
      }
    }
  }
});
